import React from 'react';
import QueryTitlesWriter from './components/QueryTitlesWriter';
import QueryTitlesReviewer from './components/QueryTitlesReviewer';
import QueryTitlesEditor from './components/QueryTitlesEditor';
import { useUserData } from '../../hooks/context/userUserData.hook';

export default function TitlesWriter() {
  const [user] = useUserData();

  if (user.role === 'WRITER' || user.role === 'TRANSLATOR') {
    return (<QueryTitlesWriter />);
  }

  if (user.role === 'REVIEWER') {
    return (<QueryTitlesReviewer />);
  }

  if (user.role === 'EDITOR') {
    return (<QueryTitlesEditor />);
  }

  return <></>;
}
